module.exports = {
      id: "telegram_black-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "svg-sprite-39ec39c5b3d32c0adb9732979a5c9627.svg#telegram_black",
      toString: function () {
        return this.url;
      }
    }